import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as Store from 'store';

import * as Actions from '../actions';
import * as Types from '../types';

interface IChildren {
  items: Types.IEntity.Workers[];
  isFetched: boolean;
  isLoaded: boolean;
}

interface IProps {
  id: number;
  params?: Partial<Types.IBranchParams>;
  onSuccess?: () => void;
  onError?: () => void;
  onFinally?: () => void;
}

const useWorkers = ({
  id,
  onSuccess = () => { },
  onError = () => { },
  onFinally = () => { } }: IProps): IChildren => {
  const dispatch = useDispatch();
  const items = useSelector<Store.Types.IState, Types.IEntity.Workers[]>(state => state.branches.workers.items);
  const isFetched = useSelector<Store.Types.IState, boolean>(state => state.branches.workers.isFetched);
  const isLoaded = useSelector<Store.Types.IState, boolean>(state => state.branches.workers.isLoaded);

  useEffect(() => {
    dispatch(Actions.Workers.request({
      id,
      callback: {
        onSuccess,
        onError,
        onFinally
      }
    }));
  }, []);

  return {
    items,
    isFetched,
    isLoaded,
  };
};

export default useWorkers;